

export const TITLE_FONT_RATIO=22;
export const DESCRIPTION_FONT_RATIO=38;
export const LOGO_HEIGHT_RATIO=22;

// Command emitted by the slide formatting toolbar and applied via document.execCommand.
export interface SlideTextCommand {
  cmd: string;
  value?: string;
}
